import { motion } from 'framer-motion';

import { useModal } from '../../../hooks/modalContext';
import { useAuth } from '../../../../auth/Auth';
import { deleteCard } from '../../../../auth/_requests';
import { showToast } from '../../../utils/showToast';
import { AlertTriangle, Clock } from 'lucide-react';
import { useState } from 'react';
import { TenantPaymentOptionStatusEnum } from '../../../utils/types';

const RemoveCard = () => {
  const { modalState, setModal } = useModal();
  const { auth } = useAuth();
  const { editCard } = modalState || {};
  const [removing, setRemoving] = useState(false);

  const isVerificationPending = editCard?.status === TenantPaymentOptionStatusEnum.VerificationPending;

  const handleConfirm = async () => {
    if (!editCard) return;

    const tenantPaymentOptionId = editCard?.id;

    try {
      setRemoving(true);
      const response = await deleteCard(auth?.data.token, tenantPaymentOptionId);
      if (response.message === 'success') {
        showToast({
          message: 'Card removed successfully! Reloading....',
          type: 'success',
        });

        setTimeout(() => {
          window.location.reload();
          setRemoving(false);
        }, 1000);
        setModal(null);
      }
    } catch (err) {
      setRemoving(false);
      showToast({
        message: 'You can’t delete a payment option that’s used in active autopay. Please remove it from autopay first.',
        type: 'error',
      });

      return;
    }
  };

  return (
    <motion.div
      className='relative w-[353px] max-h-[368px] bg-[#FFF] rounded-[12px] flex flex-col overflow-auto px-10 py-10 justify-center items-center'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {isVerificationPending ? (
        <>
          <div className='flex justify-center mb-4'>
            <Clock className='text-[#F59E0B] w-8 h-8' />
          </div>
          <span className='text-main text-lg font-semibold text-center mb-4'>
            Verification in progress
          </span>
          <span className='text-[#6B7285] text-sm text-center mb-2 leading-relaxed'>
            You can't delete this card yet because payment verification is still pending. Please wait
            until the verification is completed.
          </span>
          <div className='flex w-full gap-5 p-5'>
            <button
              className='submitBtn w-full'
              onClick={() => {
                setModal(null);
              }}
            >
              Got it
            </button>
          </div>
        </>
      ) : (
        <>
          <AlertTriangle className='text-[#B70D0D]' />

          <span className='text-main text-base text-center mt-2 mb-6'>
            Are you sure you want to remove this card? This action cannot be undone.
          </span>
          <div className='flex justify-between w-full gap-5 p-5'>
            <button
              className='cancelBtn w-full'
              onClick={() => {
                setModal(null);
              }}
            >
              Cancel
            </button>
            <button
              className='submitBtn w-full'
              onClick={() => {
                handleConfirm();
              }}
            >
              {removing ? 'Removing...' : 'Remove'}
            </button>
          </div>
        </>
      )}
    </motion.div>
  );
};

export { RemoveCard };
